import styled from 'styled-components'

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
`

export default ButtonContainer
